<template>
    <RefetchSubAssembly></RefetchSubAssembly>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const RefetchSubAssembly = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/RefetchSubAssembly.vue"
    )
);

export default {
    name: "Project_HelpRefetchSubAssembly", //The name you are in should not equal the name of the component you are importing.
    components: { RefetchSubAssembly, AuthLayout },
};
</script>
